export default __webpack_public_path__ + "static/media/branchenkonfigurator.29088bbf.webp";